module.exports = __webpack_public_path__ + "img/bayer.482d0f63.png";